


























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapState } from "vuex";
// @ts-ignore
import { ExternalLinkIcon } from "vue-feather-icons";
import Invoice from "@/models/invoice";

@Component({
  components: {
    ExternalLinkIcon,
  },
  computed: {
    ...mapState("invoices", ["invoices"]),
  },
})
export default class Invoices extends Vue {
  loading = false;
  invoices!: Array<Invoice>;

  mounted() {
    this.$nextTick(() => {
      this.loading = true;
      this.$store
        .dispatch("invoices/get")
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    });
  }

  openReceipt(url: string) {
    window.open(url, "_blank");
  }
}
